import React from "react";
import "../assets/css/questionpages.css";

const InfoPopup = ({ open, onClose, notes }) => {
  if (!open) return null;

  const formatNotes = (notes) => {
    if (!notes) return "";

    return notes
      .replace(/\n/g, "<br />") // Convert new lines
      .replace(/>\s?/g, "• "); // Convert "> text" → "• text"
  };

  return (
    <div className="popup-overlay" style={{ fontFamily: "Roboto, sans-serif" }}>
      <div className="popup-box1">
        <div className="popup-header1">
          <span className="popup-icon">i</span>
          <h2
            className="color-info"
            style={{ fontWeight: "400", fontSize: "24px" }}
          >
            Information{" "}
          </h2>
        </div>

        <div
          className="popup-text"
          style={{ fontWeight: "300", fontSize: "18px" }}
        >
          {/* {notes.split("\n").map((line, index) => (
            <div key={index}>{line}</div>
          ))} */}
          {notes.split("\n").map((line, index) => (
            <div key={index}>{line.replace(/>/g, "•")}</div>
          ))}
        </div>

        <button
          className="popup-close1"
          style={{ fontWeight: "300", fontSize: "18px" }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default InfoPopup;
